module.exports = __webpack_public_path__ + "04_veryshort_gold.67a3406c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_veryshort_gold.png
// module id = yxQJ
// module chunks = 0